import { useMemo } from 'react';
import { useMechanicValidatorCityImprovements } from '../../../store/selectors/useMechanicValidatorCityImprovements.ts';
import { useMechanicValidatorProgressCards } from '../../../store/selectors/useMechanicValidatorProgressCards.ts';
import { cardEnumsToCardState } from '../../../utils/cards.ts';
import { CardDataController } from '@colonist/game-card-types';
export const usePlayerInfoSectionContentCKProps = (playerColor)=>{
    const progressCardsValidator = useMechanicValidatorProgressCards();
    const cityImprovementsValidator = useMechanicValidatorCityImprovements();
    const progressCardsPlayerHand = progressCardsValidator === null || progressCardsValidator === void 0 ? void 0 : progressCardsValidator.getProgressCardsPlayerValidator(playerColor).progressCards.cards;
    if (progressCardsPlayerHand == undefined) return null;
    const cityImprovementPlayerState = cityImprovementsValidator === null || cityImprovementsValidator === void 0 ? void 0 : cityImprovementsValidator.getPlayerCityImprovementsState(playerColor);
    if (cityImprovementPlayerState == undefined) return null;
    return useMemo(()=>{
        const progressCardBacks = CardDataController.getCardBacksForCards(progressCardsPlayerHand);
        const progressCardStateUnordered = cardEnumsToCardState(progressCardBacks);
        return {
            progressCardState: progressCardStateUnordered,
            cityImprovementState: cityImprovementPlayerState
        };
    }, [
        progressCardsPlayerHand,
        cityImprovementPlayerState
    ]);
};
